import React from "react";

interface Props {
 id?: string;
 className?: string;
 style?: React.CSSProperties;
 children?: React.ReactNode;
}

const Col: React.FC<Props> = ({ children, className, ...rest }) => {
 return (
  <div className={`${className ?? ""}`} {...rest}>
   {children}
  </div>
 );
};

export default Col;
